import { ActivityFailedEventDetails } from "./ActivityFailedEventDetails";
import { ActivityScheduledEventDetails } from "./ActivityScheduledEventDetails";
import { ActivityScheduleFailedEventDetails } from "./ActivityScheduleFailedEventDetails";
import { ActivityStartedEventDetails } from "./ActivityStartedEventDetails";
import { ActivitySucceededEventDetails } from "./ActivitySucceededEventDetails";
import { ActivityTimedOutEventDetails } from "./ActivityTimedOutEventDetails";
import { EvaluationFailedEventDetails } from "./EvaluationFailedEventDetails";
import { ExecutionAbortedEventDetails } from "./ExecutionAbortedEventDetails";
import { ExecutionFailedEventDetails } from "./ExecutionFailedEventDetails";
import { ExecutionRedrivenEventDetails } from "./ExecutionRedrivenEventDetails";
import { ExecutionStartedEventDetails } from "./ExecutionStartedEventDetails";
import { ExecutionSucceededEventDetails } from "./ExecutionSucceededEventDetails";
import { ExecutionTimedOutEventDetails } from "./ExecutionTimedOutEventDetails";
import { LambdaFunctionFailedEventDetails } from "./LambdaFunctionFailedEventDetails";
import { LambdaFunctionScheduledEventDetails } from "./LambdaFunctionScheduledEventDetails";
import { LambdaFunctionScheduleFailedEventDetails } from "./LambdaFunctionScheduleFailedEventDetails";
import { LambdaFunctionStartFailedEventDetails } from "./LambdaFunctionStartFailedEventDetails";
import { LambdaFunctionSucceededEventDetails } from "./LambdaFunctionSucceededEventDetails";
import { LambdaFunctionTimedOutEventDetails } from "./LambdaFunctionTimedOutEventDetails";
import { MapIterationEventDetails } from "./MapIterationEventDetails";
import { MapRunFailedEventDetails } from "./MapRunFailedEventDetails";
import { MapRunRedrivenEventDetails } from "./MapRunRedrivenEventDetails";
import { MapRunStartedEventDetails } from "./MapRunStartedEventDetails";
import { MapStateStartedEventDetails } from "./MapStateStartedEventDetails";
import { StateEnteredEventDetails } from "./StateEnteredEventDetails";
import { StateExitedEventDetails } from "./StateExitedEventDetails";
import { TaskFailedEventDetails } from "./TaskFailedEventDetails";
import { TaskScheduledEventDetails } from "./TaskScheduledEventDetails";
import { TaskStartedEventDetails } from "./TaskStartedEventDetails";
import { TaskStartFailedEventDetails } from "./TaskStartFailedEventDetails";
import { TaskSubmitFailedEventDetails } from "./TaskSubmitFailedEventDetails";
import { TaskSubmittedEventDetails } from "./TaskSubmittedEventDetails";
import { TaskSucceededEventDetails } from "./TaskSucceededEventDetails";
import { TaskTimedOutEventDetails } from "./TaskTimedOutEventDetails";

export class HistoryEvent {
  activityFailedEventDetails?: ActivityFailedEventDetails;
  activityScheduledEventDetails?: ActivityScheduledEventDetails;
  activityScheduleFailedEventDetails?: ActivityScheduleFailedEventDetails;
  activityStartedEventDetails?: ActivityStartedEventDetails;
  activitySucceededEventDetails?: ActivitySucceededEventDetails;
  activityTimedOutEventDetails?: ActivityTimedOutEventDetails;
  evaluationFailedEventDetails?: EvaluationFailedEventDetails;
  executionAbortedEventDetails?: ExecutionAbortedEventDetails;
  executionFailedEventDetails?: ExecutionFailedEventDetails;
  executionRedrivenEventDetails?: ExecutionRedrivenEventDetails;
  executionStartedEventDetails?: ExecutionStartedEventDetails;
  executionSucceededEventDetails?: ExecutionSucceededEventDetails;
  executionTimedOutEventDetails?: ExecutionTimedOutEventDetails;
  id?: number;
  lambdaFunctionFailedEventDetails?: LambdaFunctionFailedEventDetails;
  lambdaFunctionScheduledEventDetails?: LambdaFunctionScheduledEventDetails;
  lambdaFunctionScheduleFailedEventDetails?: LambdaFunctionScheduleFailedEventDetails;
  lambdaFunctionStartFailedEventDetails?: LambdaFunctionStartFailedEventDetails;
  lambdaFunctionSucceededEventDetails?: LambdaFunctionSucceededEventDetails;
  lambdaFunctionTimedOutEventDetails?: LambdaFunctionTimedOutEventDetails;
  mapIterationAbortedEventDetails?: MapIterationEventDetails;
  mapIterationFailedEventDetails?: MapIterationEventDetails;
  mapIterationStartedEventDetails?: MapIterationEventDetails;
  mapIterationSucceededEventDetails?: MapIterationEventDetails;
  mapRunFailedEventDetails?: MapRunFailedEventDetails;
  mapRunRedrivenEventDetails?: MapRunRedrivenEventDetails;
  mapRunStartedEventDetails?: MapRunStartedEventDetails;
  mapStateStartedEventDetails?: MapStateStartedEventDetails;
  previousEventId?: number;
  stateEnteredEventDetails?: StateEnteredEventDetails;
  stateExitedEventDetails?: StateExitedEventDetails;
  taskFailedEventDetails?: TaskFailedEventDetails;
  taskScheduledEventDetails?: TaskScheduledEventDetails;
  taskStartedEventDetails?: TaskStartedEventDetails;
  taskStartFailedEventDetails?: TaskStartFailedEventDetails;
  taskSubmitFailedEventDetails?: TaskSubmitFailedEventDetails;
  taskSubmittedEventDetails?: TaskSubmittedEventDetails;
  taskSucceededEventDetails?: TaskSucceededEventDetails;
  taskTimedOutEventDetails?: TaskTimedOutEventDetails;
  timestamp?: Date;
  type?: string;
}
